import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context8, _context9; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context8 = ownKeys(Object(t), !0)).call(_context8, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context9 = ownKeys(Object(t))).call(_context9, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.small.js";
import React from "react";
import { CustomRaiseTypography } from "componentLibrary/theme/RaiseTypography";
import styles from "./button.module.scss";
import { Icon, RaiseColors } from "componentLibrary";
// please refer to the following link for the button you are looking for
// https://www.figma.com/design/yg7J0qZnn7wX9fLBBYgVdy/Responsive---Design-System?node-id=5339-6143&m=dev
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ButtonVariantEnum = /*#__PURE__*/function (ButtonVariantEnum) {
  ButtonVariantEnum["primary"] = "primary";
  ButtonVariantEnum["secondary"] = "secondary";
  ButtonVariantEnum["text"] = "text";
  ButtonVariantEnum["textLink"] = "textLink";
  ButtonVariantEnum["iconPrimary"] = "iconPrimary";
  ButtonVariantEnum["iconSecondary"] = "iconSecondary";
  return ButtonVariantEnum;
}({});
export var ButtonSizeEnum = /*#__PURE__*/function (ButtonSizeEnum) {
  ButtonSizeEnum["large"] = "large";
  ButtonSizeEnum["medium"] = "medium";
  ButtonSizeEnum["small"] = "small";
  ButtonSizeEnum["xsmall"] = "xsmall";
  ButtonSizeEnum["xxsmall"] = "xxsmall";
  return ButtonSizeEnum;
}({});
var getTypography = function getTypography(size) {
  switch (size) {
    case ButtonSizeEnum.large:
      return CustomRaiseTypography.paragraph_large;
    case ButtonSizeEnum.medium:
      return CustomRaiseTypography.paragraph_medium;
    case ButtonSizeEnum.small:
      return CustomRaiseTypography.paragraph_small;
    case ButtonSizeEnum.xsmall:
      return CustomRaiseTypography.paragraph_xsmall;
    case ButtonSizeEnum.xxsmall:
      return CustomRaiseTypography.paragraph_xsmall;
    default:
      throw new Error("unsupported button size");
  }
};
var getButtonStyles = function getButtonStyles(variant, size) {
  var _context, _context2, _context3, _context4, _context5, _context6, _context7;
  var buttonStyles = "";
  if (!_includesInstanceProperty(_context = _Object$values(ButtonVariantEnum)).call(_context, variant)) {
    // Ideally throw error here, but we don't have thorough error catching
    // So crashing a page because of a button style is not desired.
    console.error("Unsupported Button variant. Please refer to ButtonVariantEnum for supported variants");
  }
  switch (variant) {
    case ButtonVariantEnum.iconPrimary:
      buttonStyles = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(styles["icon-button-base"], " ")).call(_context3, styles["icon-button-".concat(size)], " ")).call(_context2, styles.primary);
      break;
    case ButtonVariantEnum.iconSecondary:
      buttonStyles = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "".concat(styles["icon-button-base"], " ")).call(_context5, styles["icon-button-".concat(size)], " ")).call(_context4, styles.secondary);
      break;
    default:
      buttonStyles = _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = "".concat(styles["button-base"], " ")).call(_context7, styles["button-".concat(size)], " ")).call(_context6, styles["".concat(variant)]);
      break;
  }
  return buttonStyles;
};
var Button = function Button(_ref) {
  var variant = _ref.variant,
    size = _ref.size,
    iconSize = _ref.iconSize,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    isActive = _ref.isActive,
    showDivider = _ref.showDivider,
    children = _ref.children,
    setToFill = _ref.setToFill,
    alignSelf = _ref.alignSelf,
    ref = _ref.ref,
    dataPendo = _ref["data-pendo"];
  var textTypography = getTypography(size);
  var buttonStyle = getButtonStyles(variant, size);
  var isIcon = variant === ButtonVariantEnum.iconPrimary || variant === ButtonVariantEnum.iconSecondary;
  var LeadingDivider = variant === ButtonVariantEnum.secondary ? /*#__PURE__*/_jsx(VerticalDivider, {
    disabled: disabled
  }) : null;
  return /*#__PURE__*/_jsxs("button", {
    "data-pendo": dataPendo,
    disabled: disabled,
    "is-active": isActive === null || isActive === void 0 ? void 0 : isActive.toString(),
    style: _objectSpread(_objectSpread({}, textTypography), {}, {
      whiteSpace: "nowrap",
      width: setToFill ? "100%" : undefined,
      alignSelf: alignSelf
    }),
    className: buttonStyle,
    onClick: onClick,
    type: "button",
    ref: ref,
    children: [leadingIcon ? iconSize ? /*#__PURE__*/_jsx(Icon, {
      className: leadingIcon,
      fontSize: iconSize
    }) : /*#__PURE__*/_jsx("div", {
      className: leadingIcon
    }) : null, showDivider && LeadingDivider, !isIcon && children, !isIcon && trailingIcon ? iconSize ? /*#__PURE__*/_jsx(Icon, {
      className: trailingIcon,
      fontSize: iconSize
    }) : /*#__PURE__*/_jsx("div", {
      className: trailingIcon
    }) : null]
  });
};
export default Button;
var VerticalDivider = function VerticalDivider(_ref2) {
  var disabled = _ref2.disabled;
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: 12,
      height: 1,
      transform: "rotate(90deg)",
      background: disabled ? RaiseColors.gray300 : RaiseColors.glacier400
    }
  });
};